import * as React from 'react';
import uniqBy from 'lodash-es/uniqBy';
import orderBy from 'lodash-es/orderBy';
import Modal from '../modal';
import Select from 'react-select';
import LoadingWithMessage from '../../../misc/components/LoadingWithMessage';
import { QueryCondition, Query, QueryFilter } from '../../api/apiTypes';

interface MultiSelectModalProps {
    header: string;
    show: boolean;
    values: Array<any>;
    options: any;
    valueKey: string;
    labelKey: string;
    onApply: (event?: any) => void;
    onClose: () => void;
    onChange: (values: any, event?: any) => void;
    onClear?: (event?: any) => void;
    isLoading?: boolean;
}

interface GenericMultiSelectModalProps {
    query: Query<any>;
    member: string;
    header: string;
    onApply: (filter: QueryFilter[]) => void;
    onClose: () => void;
    onClear: (member: string) => void;
    onGet: (query: Query<any>) => Promise<Query<any>>;
}

export const GetQueryFilter = (query: Query<any>, member: string, condition: QueryCondition): QueryFilter => {
    return query.Filters.find(filter => filter.Member === member && filter.Condition === condition);
}

export default class MultiSelectModal extends React.Component<MultiSelectModalProps> {
    render() {
        const { header, show, values, options, valueKey, labelKey, onApply, onClose, onChange, isLoading, onClear } = this.props;
        const handleClear = onClear ? onClear : (event?: any) => {
            onChange([], event);
            onApply(event);
        };

        //Casting to a boolean for safety.
        const loading = !!isLoading;

        return <Modal show={show} closeModalHandler={onClose} header={header}>
            <div className='modal-body'>

                {loading ? <LoadingWithMessage message={"Loading..."} /> : <div className='row'>
                    <div className='col-md-12 form-group'>
                        <label>Match</label>
                        <Select
                            id="multi-select-modal-select"
                            options={options}
                            value={options && values && options.filter(o => values.includes(o[valueKey]))}
                            getOptionValue={o => o[valueKey]}
                            getOptionLabel={o => o[labelKey]}
                            isMulti={true}
                            classNamePrefix="multiSelect"
                            onChange={(v) => onChange(v)}
                        />
                    </div>
                </div>}


            </div>
            <div className='modal-footer'>
                <button disabled={loading} className='btn btn-primary' onClick={onApply} data-automationid="modal-submit">OK</button>
                <button disabled={loading} className='btn btn-danger' onClick={handleClear}>Clear</button>
            </div>
        </Modal>
    }
}

export const GenericMultiSelectModal = ({ query, member, header, onApply, onClear, onClose, onGet }: GenericMultiSelectModalProps): JSX.Element => {

    const condition = QueryCondition.Equal;
    const queryFilter = GetQueryFilter(query, member, condition) || { Values: [] };
    const [values, setValues] = React.useState<string[]>(queryFilter.Values as string[]);
    const [allOptions, setAllOptions] = React.useState<any[]>(null);

    React.useEffect(() => {
        onGet({}).then(response => {
            const uniqueOrdered = orderBy(uniqBy(response.Data, member), member);
            setAllOptions(uniqueOrdered);
        });
    }, []);

    return (
        <MultiSelectModal
            header={header + ' Filter'}
            isLoading={!allOptions}
            show={true}
            options={allOptions}
            valueKey={member}
            labelKey={member}
            values={values}
            onChange={(updatedValues) => {
                setValues(updatedValues.length > 0 ? updatedValues.map(uv => uv[member]) : null);
            }}
            onApply={() => {
                onApply([{ Member: member, Condition: condition, Values: values }]);
            }}
            onClear={() => {
                onClear(member);
            }}
            onClose={onClose}
        />
    )
}
